import classJoin from 'classjoin';
import {h} from 'preact';
import AbstractVisualStep, {AbstractVisualStepState} from './AbstractVisualStep';
// import fetchVisualBuilding from './asyncActions/fetchVisualBuilding';
import fetchVisualOverview from './asyncActions/fetchVisualOverview';
import fetchVisualSection from './asyncActions/fetchVisualSection';
import {
	setBuilding,
	setStep,
	setTooltip,
	setTooltipVisibility,
} from './Store/creators/visualData';
import {dispatch, getState} from './Store/index';
import {StateVisualMapItem, StateVisualStep} from './Store/State';

/**
 * Component Properties.
 */
interface VisualOverviewProps
{
	/** Внутреннее название вида */
	view: string;
	/** Следующий вид */
	nextView: string;
	/** Путь до изображения */
	image: string;
	/** Карта областей */
	map: StateVisualMapItem[];
}

/**
 * Component State.
 */
type VisualOverviewState = AbstractVisualStepState;

/**
 * Общий экран.
 */
class VisualOverview
	extends AbstractVisualStep<VisualOverviewProps, VisualOverviewState>
{
	/**
	 * Rendered component mounted to the DOM.
	 */
	public componentDidMount(): void
	{
		super.componentDidMount();
		
		const {visualData: {step, prevStep, overview}} = getState();
		
		if ( step < prevStep )
		{
			fetchVisualOverview( overview.view );
		}
	}
	
	/**
	 * Before render, return false to skip render.
	 */
	/*public shouldComponentUpdate( {image, map}: VisualOverviewProps ): boolean
	{
		return (
			( image !== this.props.image )
			|| ( map !== this.props.map )
		);
	}*/
	
	/**
	 * Render component.
	 */
	public render(
		{nextView, image, map}: VisualOverviewProps,
		{aspectRatioLessThanImage}: VisualOverviewState,
	): JSX.Element
	{
		return (
			<section class="overview">
				<header>
					<h2>Выберите секцию</h2>
				</header>
				{
					nextView
					? (
						<button
							type="button"
							class="switch-view"
							onClick={this.onSwitchViewClick}
						>
							Другой ракурс
						</button>
					)
					: ''
				}
				<div
					class={classJoin(
						{
							[AbstractVisualStep.CLASS_INVERT_ASPECT]: aspectRatioLessThanImage,
						},
						['map'],
					)}
					ref={this.refMapContainer}
				>
					<img
						src={image}
						alt=""
					/>
					<svg
						width="1920" height="1080"
						viewBox="0 0 1920 1080"
					>
						{/* <use xlinkHref="/images/choose-visual/compasses.svg#overview" width="1920" height="1080" /> */}
						{map.map(
							( area: StateVisualMapItem ) => (
								<path
									class={area.available === 0 ? 'disabled' : ''}
									d={area.path}
									data-target={area.target}
									data-available={area.available}
									onClick={this.onAreaClick}
									onTouchStart={this.onAreaTouch}
									onMouseEnter={this.onAreaMouseEnter}
									onMouseLeave={this.onAreaMouseLeave}
								/>
							),
						)}
					</svg>
				</div>
			</section>
		);
	}
	
	/**
	 * При нажатии на область.
	 */
	private onAreaClick = ( event: Event ): void =>
	{
		if ( this.areaTouchTarget && ( this.areaTouchCount < 2 ) )
		{
			return;
		}
		
		this.areaTouchCount = 0;
		this.areaTouchTarget = null;
		
		const target = event.target as Element;
		const targetId = target.getAttribute( 'data-target' );
		
		if ( !targetId )
		{
			return;
		}
		
		const available = target.getAttribute( 'data-available' ) || '0';
		
		if ( available === '0' )
		{
			return;
		}
		
		/* if ( targetId === '2' )
		{ */
			dispatch(
				setBuilding(
					{
						building: '1',
						view: this.props.view,
						nextView: '',
						image: '',
						map: [],
					},
				),
			);
			dispatch( setStep( StateVisualStep.SECTION ) );
			fetchVisualSection( targetId, this.props.view );
		/* }
		else
		{
			dispatch( setStep( StateVisualStep.BUILDING ) );
			fetchVisualBuilding( targetId, this.props.view );
		} */
		
		dispatch( setTooltipVisibility( false ) );
	}
	
	/**
	 * При наведении курсора на область.
	 */
	private onAreaMouseEnter = ( event: Event ): void =>
	{
		const target = event.target as Element;
		const targetId = target.getAttribute( 'data-target' );
		
		if ( !targetId )
		{
			return;
		}
		
		const available = target.getAttribute( 'data-available' ) || '0';
		
		dispatch(
			setTooltip(
				targetId + ' секция', // ' корпус',
				available + ' квартир в продаже',
			),
		);
	}
	
	/**
	 * При нажатии на «Другой ракурс».
	 */
	private onSwitchViewClick = (): void =>
	{
		fetchVisualOverview( this.props.nextView );
	}
}

/**
 * Module.
 */
export {
	VisualOverview as default,
	VisualOverviewProps,
	VisualOverviewState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/VisualOverview.tsx